import { createReducer, on } from '@ngrx/store';
import {
  initialRewardsState,
  initialRewardState,
  initialRewardsCatAndSubCatPreferenceState,
} from './rewards.state';
import {
  clearRewardDetails,
  getRewardDetails,
  getRewardDetailsFailure,
  getRewards,
  getRewardsFailure,
  getRewardsCatAndSubCatPreference,
  getRewardsCatAndSubCatPreferenceFailure,
  getRewardsCatAndSubCatPreferenceSuccess,
  getRewardsSuccess,
  getRewardDetailsSuccess,
  updateRewardsParams,
  setRewardQty,
  setRewardSpinner,
  updateRewardsCatAndSubCatPreferenceParams,
} from './rewards.actions';

// export const _rewardsReducer get all rewards listing
const _rewardsReducer = createReducer(
  initialRewardsState,
  on(getRewards, (state) => ({ ...state, loading: true, error: null })),
  on(getRewardsSuccess, (state, { rewards }) => {
    return {
      ...state,
      rewards,
      loading: false,
      error: null,
    };
  }),
  on(getRewardsFailure, (state, { error }) => {
    return {
      ...state,
      loading: false,
      error,
    };
  }),
  on(updateRewardsParams, (state, { params }) => {
    return {
      ...state,
      params,
      // filtersCount,
    };
  }),
  on(setRewardQty, (state, { rewardQty }) => {
    const existing = state.rewardQty.rewardQuantities.find(
      (r) => r.rewardId === rewardQty.rewardId,
    );
    let updatedQuantities = [];

    if (existing) {
      updatedQuantities = state.rewardQty.rewardQuantities.map((r) =>
        r.rewardId == rewardQty.rewardId ? rewardQty : r,
      );
    } else {
      updatedQuantities = [...state.rewardQty.rewardQuantities, rewardQty];
    }

    return {
      ...state,
      rewardQty: {
        rewardQuantities: updatedQuantities,
      },
    };
  }),
  on(setRewardSpinner, (state, { spinner }) => ({
    ...state,
    spinner,
  })),
);

// export const _rewardReducer get single reward by Id
const _rewardDetailReducer = createReducer(
  initialRewardState,
  on(getRewardDetails, (state) => ({ ...state, loading: true, error: null })),
  on(getRewardDetailsSuccess, (state, { reward }) => ({
    ...state,
    reward,
    loading: false,
    error: null,
  })),
  on(getRewardDetailsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(clearRewardDetails, (state) => ({
    ...state,
    reward: null,
    loading: false,
    saving: false,
    error: null,
  })),
);

// export const _rewardsCatAndSubCatPreferenceReducer listing
const _rewardsCatAndSubCatPreferenceReducer = createReducer(
  initialRewardsCatAndSubCatPreferenceState,
  on(getRewardsCatAndSubCatPreference, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(
    getRewardsCatAndSubCatPreferenceSuccess,
    (state, { rewardCategories }) => ({
      ...state,
      rewardCategories,
      loading: false,
      error: null,
    }),
  ),
  on(getRewardsCatAndSubCatPreferenceFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(
    updateRewardsCatAndSubCatPreferenceParams,
    (state, { rewardCatAndSubCatParams }) => {
      return {
        ...state,
        params: rewardCatAndSubCatParams,
      };
    },
  ),
);

export function rewardsReducer(state: any, action: any) {
  return _rewardsReducer(state, action);
}

export function rewardDetailReducer(state: any, action: any) {
  return _rewardDetailReducer(state, action);
}

export function rewardsCatAndSubCatPreferenceReducer(state: any, action: any) {
  return _rewardsCatAndSubCatPreferenceReducer(state, action);
}
